import { render, staticRenderFns } from "./page-not-available.vue?vue&type=template&id=4a89eb06&scoped=true&"
import script from "./page-not-available.vue?vue&type=script&lang=ts&"
export * from "./page-not-available.vue?vue&type=script&lang=ts&"
import style0 from "./page-not-available.vue?vue&type=style&index=0&id=4a89eb06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a89eb06",
  null
  
)

export default component.exports